export const FallbackLanguage = "en";
export const DefaultNamespace = "base";
export const CommonResourceNamespaces = ["base", "words", "terms", "messages"];
export const generateCommonResourceNamespaces = () => [
  ...CommonResourceNamespaces
];

/**
 * Feature namespaces are loaded lazily when the feature route is mounted.
 * Each key maps to the folder name under locales/features/.
 */
export const FeatureNamespaces = {
  receivedInvoices: "receivedInvoices",
  eInvoicingIdentifiers: "eInvoicingIdentifiers"
} as const;

export type FeatureNamespace =
  (typeof FeatureNamespaces)[keyof typeof FeatureNamespaces];

export const SupportedLanguages = [
  "en",
  "en-US",
  "en-GB",
  "en-CA",
  "fr",
  "fr-FR",
  "fr-CA",
  "es",
  "es-ES",
  "de",
  "de-DE",
  "pt",
  "pt-PT"
] as const;

export type SupportedLanguage = (typeof SupportedLanguages)[number];

export type LangResources = {
  [ns: string]: { [key: string]: string };
};

/**
 * Compute the fallback language.
 * For now returns the static FallbackLanguage.
 */
export const ComputeFallbackLanguageForTest = (): SupportedLanguage => {
  return FallbackLanguage;
};

/****************** E-Invoicing i18n Constants *******************/

export const MFEName = "Settings" as const;

/**
 * Namespaces loaded at app startup (via I18nSetter).
 * Feature-specific namespaces are loaded lazily per-route instead.
 */
export const EInvoicingNamespaces = [] as const;

export const ActiveNamespaces: Record<string, readonly string[]> =
  Object.freeze({
    [MFEName]: EInvoicingNamespaces
  });
